<template>
	<core-modal
		:name="`om-analytics`"
		class="om-om-analytics integration"
		:width="881"
	>
		<modals-header name="om-analytics"/>
		<modals-content>
			<h2>OptinMonster’s Conversion Analytics</h2>
			<p>With Conversion Analytics, we make it easy to get the stats that matter so you can improve lead generation. You can analyze clicks, views and overall conversion rate for each of your optin campaigns.</p>
			<core-button :href="url" target="_blank" rel="noopener" :linkStyle="true" :arrow="true">Learn more about Analytics</core-button>
		</modals-content>
	</core-modal>
</template>
<script>
export default {
	computed : {
		url () {
			return this.$urls.utmLink(this.$urls.marketing('features/conversion-analytics/'), {
				utm_medium : 'IntegrationsOmAnalytics',
			})
		},
	},
}
</script>
<style lang="scss">
@import '../../../assets/scss/variables';
.om-om-analytics {
	.header {
		background-color: transparent!important;
		padding: 30px 30px 0!important;

		.close {
			button {
				color: #B2B4B8;
			}
		}
	}

	.content {
		align-items: center;
		display: flex;
		flex-direction: column;
		padding: 0 100px 40px!important;

		h2 {
			font-weight: $font_bold;
			text-align: center;
			font-size: 24px;
			line-height: 140%;
			margin-top: 10px;
		}

		p {
			font-size: 16px;
			text-align: center;
			padding: 0 35px;
			width: 560px;
		}

		.om-om-analytics-cards {
			margin-bottom: 20px;
		}
	}
}
</style>
